import { createAction, props } from '@ngrx/store';
import { ServiceCenter } from 'app/features/settings/models/service-center.model';

// Service Centers
export const triggerServiceCenters = createAction('[Service Centers] Load Service Centers');
export const serviceCentersSuccess = createAction(
  '[Service Centers]  Service Centers Success',
  props<{ serviceCenters: ServiceCenter[] }>()
);
export const serviceCentersFailure = createAction(
  '[Service Centers]  Service Centers Failure',
  props<{ error: string }>()
);
